<template>
  <ul :class="classes">
    <slot></slot>
  </ul>
</template>

<script>
import themeMixins from '@mixins/officialStore/themeMixins'
export default {
  mixins: [themeMixins]
}
</script>
